import { render } from "./OnboardingForm.vue?vue&type=template&id=f766eddc&scoped=true&ts=true"
import script from "./OnboardingForm.vue?vue&type=script&lang=ts"
export * from "./OnboardingForm.vue?vue&type=script&lang=ts"

import "./OnboardingForm.vue?vue&type=style&index=0&id=f766eddc&lang=scss"
import "./OnboardingForm.vue?vue&type=style&index=1&id=f766eddc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f766eddc"]])

export default __exports__